var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { sceneFlyover } from "./utils/sceneFlyover";
import { defaultRendererConfig } from "./index";
export function layeredImageryFlyover1(container, description) {
    return __awaiter(this, void 0, void 0, function* () {
        description.innerHTML =
            "<h1>" +
                "Layered Imagery Flyover 1" +
                "</h1>" +
                "<p>" +
                "The camera will fly over the globe with a specific layered imagery source. The globe should render normally." +
                "</p>";
        const initialWait = 5;
        const time = 3;
        const DURATIONS = [0, initialWait, time, time, time, time, time];
        const POSITIONS = [
            { longitude: 2.5304691158303156, latitude: -0.6583091305065227, height: 27051.2552842789 },
            { longitude: 2.5304691158303156, latitude: -0.6583091305065227, height: 27051.2552842789 },
            { longitude: 2.530688841737194, latitude: -0.6587100304622651, height: 76.63796461279674 },
            { longitude: 2.5306723084819027, latitude: -0.6587116796143979, height: 27.0716703972088 },
            { longitude: 2.5306853109724567, latitude: -0.6587113267321771, height: 4.3325227359058065 },
            { longitude: 2.5306947624286513, latitude: -0.6587115103058856, height: 1.994532142595248 },
        ];
        const FOCUSES = [
            { longitude: 2.5306896247798534, latitude: -0.6587107874329975, height: 0.6626293559922504 },
            { longitude: 2.5306896247798534, latitude: -0.6587107874329975, height: 0.6626293559922504 },
            { longitude: 2.5306896247798534, latitude: -0.6587107874329975, height: 0.6626293559922504 },
            { longitude: 2.5306896247798534, latitude: -0.6587107874329975, height: 0.6626293559922504 },
            { longitude: 2.5306853943103937, latitude: -0.6587111181879071, height: 0.1142490625907045 },
            { longitude: 2.530694189700873, latitude: -0.6587116920051161, height: 0.22322603982530081 },
        ];
        const token = "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJqdGkiOiJkZWRiYmRiYi00NzkwLTRhNmUtOTNjNS0xNTdmMmQ2YWU2YjYiLCJpZCI6NjU2MjMsImlhdCI6MTYzMDM4MDgyNn0.AkraHLm6RAZZDYB9Rqf3kcrOC8Lx9Iu2aYg2aO3jIbM";
        yield sceneFlyover(defaultRendererConfig(container, token), DURATIONS, POSITIONS, FOCUSES, (renderer) => __awaiter(this, void 0, void 0, function* () {
            // Intentionally dropped promise, blocking is not needed
            const _ = renderer
                .getWorld()
                .getGlobe()
                .setTileLayers([
                {
                    type: "osm",
                },
                {
                    type: "tms",
                    url: "https://s3.ap-southeast-2.amazonaws.com/skand.development.nathan.tiler-test-content/gdal2tiles_ortho/",
                },
            ]);
        }));
    });
}
